/* eslint-disable camelcase */
export const firebase_medpro = {
  apiKey: "AIzaSyD8eFYzbdyThCdpJsoyk6OUqugXP7an6pM",
  authDomain: "medpro-dkkb.firebaseapp.com",
  databaseURL: "https://medpro-dkkb.firebaseio.com",
  projectId: "medpro-dkkb",
  storageBucket: "medpro-dkkb.appspot.com",
  messagingSenderId: "986492668143",
  appId: "1:986492668143:web:c8ae0a818531bbba12b31a",
  measurementId: "G-3JBV9PGFS6"
};

export const firebase_dalieuhcm = {
  apiKey: "AIzaSyDwQVO2LZTSAJHu9SwZh6KW8a9Zp68g_DU",
  authDomain: "bvdalieu-b098e.firebaseapp.com",
  databaseURL: "https://bvdalieu-b098e.firebaseio.com",
  projectId: "bvdalieu-b098e",
  storageBucket: "bvdalieu-b098e.appspot.com",
  messagingSenderId: "335999438461",
  appId: "1:335999438461:web:16fb9dd11ff973e7f1eb14",
  measurementId: "G-WJPVKY66M8",
  clientId: "112956123847370780160"
};

export const firebase_nhidong1 = {
  apiKey: "AIzaSyDj27eEJwWqroltHUg89Ia04zFbwTQNcrA",
  authDomain: "dkkbnhidong1.firebaseapp.com",
  databaseURL: "https://dkkbnhidong1.firebaseio.com",
  projectId: "dkkbnhidong1",
  storageBucket: "dkkbnhidong1.appspot.com",
  messagingSenderId: "679400719931",
  appId: "1:679400719931:web:57c8135e305584c57f3e1e",
  measurementId: "G-YP50HKEWGM",
  clientId: "112956123847370780160"
};

export const firebase_medpro2 = {
  apiKey: "AIzaSyCdhJR9lKMSgu-GzhDJUellF5jKxEQ0L-Y",
  authDomain: "medpro-dkkb2.firebaseapp.com",
  databaseURL: "https://medpro-dkkb2-default-rtdb.firebaseio.com",
  projectId: "medpro-dkkb2",
  storageBucket: "medpro-dkkb2.appspot.com",
  messagingSenderId: "59026800666",
  appId: "1:59026800666:web:135769d9b66f0fffe0d1a3",
  measurementId: "G-H1MKTJ8DJ1"
};

export const firebase_umc = {
  apiKey: "AIzaSyBGtmivoEOv9RxfrWBKQQC-iNhtz_Z_7C4",
  authDomain: "medpro-1e443.firebaseapp.com",
  databaseURL: "https://medpro-1e443.firebaseio.com",
  projectId: "medpro-1e443",
  storageBucket: "medpro-1e443.appspot.com",
  messagingSenderId: "44942685130",
  appId: "1:44942685130:web:98068ab748d5dbc42bd533",
  measurementId: "G-VX2HGS37BS"
};

export const AppId_dalieu = "2797456492485843470";

export const AppId_nhidong1 = "2502058124973201544";

export const AppId_medpro = "637628968723875573";

export const AppId_dkanphuoc = "734510069421593307";

export const AppId_umc = "3886070095063898011";

export const AppId_trungvuong = "1220206114835674859";
